import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
} from '@mui/material';
import {
  Search,
  Add,
  Phone,
  Email,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const CTASection = () => {
  const navigate = useNavigate();

  const ctaCards = [
    {
      icon: <Search />,
      title: 'Find Your Dream Home',
      description: 'Browse through thousands of properties and find the perfect match for your needs.',
      buttonText: 'Search Properties',
      buttonAction: () => navigate('/properties'),
      primary: true,
    },
    {
      icon: <Add />,
      title: 'List Your Property',
      description: 'Sell or rent your property with our comprehensive listing services.',
      buttonText: 'Add Property',
      buttonAction: () => navigate('/add-property'),
      primary: false,
    },
  ];

  return (
    <Box sx={{ py: 8, backgroundColor: 'white' }}>
      <Container maxWidth="lg">
        {/* Main CTA Section */}
        <Box
          sx={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            borderRadius: 4,
            p: 6,
            textAlign: 'center',
            color: 'white',
            mb: 6,
          }}
        >
          <Typography
            variant="h3"
            component="h2"
            sx={{
              fontWeight: 700,
              mb: 2,
            }}
          >
            Ready to Get Started?
          </Typography>
          <Typography
            variant="h6"
            sx={{
              mb: 4,
              opacity: 0.9,
              maxWidth: 600,
              mx: 'auto',
            }}
          >
            Join thousands of satisfied clients who have found their perfect properties with us
          </Typography>
          
          <Grid container spacing={3} justifyContent="center">
            {ctaCards.map((cta, index) => (
              <Grid item xs={12} md={6} key={index}>
                <Card
                  sx={{
                    backgroundColor: cta.primary 
                      ? 'rgba(255, 255, 255, 0.15)' 
                      : 'rgba(255, 255, 255, 0.1)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    borderRadius: 3,
                    color: 'white',
                    height: '100%',
                    transition: 'all 0.3s ease-in-out',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      backgroundColor: cta.primary 
                        ? 'rgba(255, 255, 255, 0.2)' 
                        : 'rgba(255, 255, 255, 0.15)',
                    },
                  }}
                >
                  <CardContent sx={{ p: 4, textAlign: 'center' }}>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        mb: 2,
                      }}
                    >
                      {React.cloneElement(cta.icon, {
                        sx: {
                          fontSize: 48,
                          color: 'rgba(255, 255, 255, 0.9)',
                        },
                      })}
                    </Box>
                    
                    <Typography
                      variant="h5"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                      }}
                    >
                      {cta.title}
                    </Typography>
                    
                    <Typography
                      variant="body1"
                      sx={{
                        mb: 3,
                        opacity: 0.9,
                        lineHeight: 1.6,
                      }}
                    >
                      {cta.description}
                    </Typography>
                    
                    <Button
                      variant={cta.primary ? 'contained' : 'outlined'}
                      size="large"
                      sx={{
                        px: 4,
                        py: 1.5,
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 600,
                        ...(cta.primary ? {
                          backgroundColor: 'white',
                          color: '#667eea',
                          '&:hover': {
                            backgroundColor: '#f5f5f5',
                          },
                        } : {
                          borderColor: 'white',
                          color: 'white',
                          '&:hover': {
                            borderColor: 'white',
                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                          },
                        }),
                      }}
                      onClick={cta.buttonAction}
                    >
                      {cta.buttonText}
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Contact Section */}
        <Box textAlign="center">
          <Typography
            variant="h4"
            sx={{
              fontWeight: 600,
              mb: 2,
              color: '#333',
            }}
          >
            Need Help? Contact Us
          </Typography>
          <Typography
            variant="h6"
            color="text.secondary"
            sx={{ mb: 4 }}
          >
            Our expert team is here to assist you with all your real estate needs
          </Typography>
          
          <Grid container spacing={3} justifyContent="center">
            <Grid item>
              <Button
                variant="outlined"
                size="large"
                startIcon={<Phone />}
                sx={{
                  px: 4,
                  py: 1.5,
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 600,
                  borderColor: '#2196F3',
                  color: '#2196F3',
                  '&:hover': {
                    borderColor: '#1976D2',
                    backgroundColor: 'rgba(33, 150, 243, 0.04)',
                  },
                }}
              >
                Call Us: 0723294696
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                size="large"
                startIcon={<Email />}
                sx={{
                  px: 4,
                  py: 1.5,
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 600,
                  background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
                  '&:hover': {
                    background: 'linear-gradient(45deg, #1976D2 30%, #1BA3D3 90%)',
                  },
                }}
              >
                Email: lewmaxsuppliers@gmail.com
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default CTASection;
